import { Actions, SUBJECTS } from '@libs/@core/security/rolePermissions';
var prefix = [
    'cashflow',
    'ap-management',
    'ar-management',
    'automation'
    // ========== Add Prefix Here ==========
];
var normalizeEntity = function (entity) {
    var subjectMap = Object.fromEntries(Object.entries(SUBJECTS).map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key.toLowerCase(), value];
    }));
    return subjectMap[entity.toLowerCase()] || entity;
};
export var parseRoute = function (pathname) {
    var segments = pathname.split('/').filter(Boolean);
    if (segments.length === 0) {
        return { subject: 'Unknown', action: Actions.VIEW };
    }
    var entity = normalizeEntity(segments[0]);
    var id = segments[1];
    var actionSegment = segments[2];
    if (segments.length > 1 && prefix.includes(segments[0])) {
        entity = normalizeEntity(segments[1]);
        id = segments[2];
        actionSegment = segments[3];
    }
    var action;
    if (!id && !actionSegment) {
        action = Actions.MANAGE;
    }
    else if (id && !actionSegment) {
        action = Actions.VIEW;
    }
    else if (actionSegment === 'edit') {
        action = Actions.EDIT;
    }
    else if (actionSegment === 'create') {
        action = Actions.CREATE;
    }
    else {
        action = Actions.VIEW;
    }
    return { subject: entity, action: action };
};
